// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Theme = require("./theme");
var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var CardioPng = require("./assets/cardio.png");
var Heart_iconSvg = require("./assets/heart_icon.svg");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.backgroundImage(/* `url */[
                    5843823,
                    CardioPng
                  ]),
              /* :: */[
                Css.backgroundRepeat(/* repeat */108828507),
                /* :: */[
                  Css.background(Css.white),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var container = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.borderRadius(Css.px(10)),
              /* :: */[
                Css.boxShadow(/* Some */[Css.px(2)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(255, 191, 194, 0.29)),
                /* :: */[
                  Css.boxSizing(Css.borderBox),
                  /* :: */[
                    Css.margin4(Css.px(60), Css.px(10), Css.px(20), Css.px(10)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var headerBox = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.background(/* `hex */[
                  5194459,
                  "FFFAFA"
                ]),
            /* :: */[
              Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
              /* :: */[
                Css.padding2(Css.px(0), Css.px(0)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.justifyContent(/* spaceAround */-485895757),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var heart = Css.style(/* :: */[
      Css.transform(/* `scale */[
            -120664438,
            /* tuple */[
              1.4,
              1.4
            ]
          ]),
      /* [] */0
    ]);

var placeHolder = Css.style(/* :: */[
      Css.width(Css.px(50)),
      /* [] */0
    ]);

var headHeader = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(4), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(5)),
        /* [] */0
      ]
    ]);

var subHeader = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.fontSize(Css.px(22)),
          /* [] */0
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.color(/* `hex */[
            5194459,
            "F66297"
          ]),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.margin4(Css.px(20), Css.px(0), Css.px(20), Css.px(0)),
          /* :: */[
            Css.padding2(Css.px(0), /* `percent */[
                  -119887163,
                  10.0
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(50), Css.px(8), Css.px(10), Css.px(8)),
                  /* :: */[
                    Css.maxWidth(Css.em(13.0)),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* container */container,
  /* inputField */inputField,
  /* headerBox */headerBox,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* heart */heart,
  /* placeHolder */placeHolder,
  /* headHeader */headHeader,
  /* subHeader */subHeader,
  /* contentBox */contentBox,
  /* someLink */someLink,
  /* settingButton */settingButton
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("WorkoutWeekCardio");

function make(week, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: container
                        }, React.createElement("div", {
                              className: headerBox
                            }, React.createElement("div", {
                                  className: horizonBox
                                }, React.createElement("img", {
                                      className: heart,
                                      alt: "logo",
                                      src: Heart_iconSvg
                                    }), React.createElement("div", {
                                      className: horizonBoxEl
                                    }, React.createElement("h1", {
                                          className: headHeader
                                        }, "Cardio"), React.createElement("h2", {
                                          className: subHeader
                                        }, "Workout")), React.createElement("div", {
                                      className: placeHolder
                                    }))), React.createElement("div", {
                              className: contentBox
                            }, "Absolviere eine moderate Cardio-Einheit deiner Wahl oder pausiere optional einen Tag. Achte darauf, dass du bei der Wahl deiner Cardio-Einheit keine Belastung wählst, die deine Regeneration zu stark beeinflussen würde.")), React.createElement("button", {
                          className: settingButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/week/" + (week + "/workoutweek/"));
                            })
                        }, "Zurück")));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/workoutWeekCardio.re
// module id = 164
// module chunks = 0